
import { utcToZonedTime, format } from 'date-fns-tz';
import moment from 'moment';

export const cats = [
  'Homeless',
  'Environment',
  'Addiction',
  'Arts And Culture',
  'Mental Health',
  'Sport',
  'Disability',
  'Seniors',
  'Education',
  'Domestic Violence',
  'Community',
  'Emergency Response',
  'Sustainability',
  'Animals',
  'Human Rights',
  'First Nations',
];

export const photos = [
  { id: 2, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg1.jpg' },
  { id: 3, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg2.jpg' },
  { id: 4, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg3.jpg' },
  { id: 5, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg4.jpg' },
  { id: 6, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg5.jpg' },
  { id: 7, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg6.jpg' },
  { id: 8, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg7.jpg' },
  { id: 9, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg8.jpg' },
  { id: 10, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg9.jpg' },
  { id: 11, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg10.jpg' },
  { id: 12, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg11.jpg' },
  { id: 13, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg12.jpg' },
  { id: 14, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg13.jpg' },
  { id: 15, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg14.jpg' },
  { id: 16, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg15.jpg' },
  { id: 17, key: 'https://dogood-dev-bucket.s3.amazonaws.com/public/oppImg16.jpg' },
];

export const weekdays = [
  'One day',
  'Every day',
  'Every Monday',
  'Every Tuesday',
  'Every Wednesday',
  'Every Thursday',
  'Every Friday',
  'Every Saturday',
  'Every Sunday',
];

export const convertWeekdays: Record<string, string[]> = {
  'One day': ['ONE_DAY'],
  'Every day': ['EVERY_DAY'],
  'Every Monday': ['EVERY_MONDAY'],
  'Every Tuesday': ['EVERY_TUESDAY'],
  'Every Wednesday': ['EVERY_WEDNESDAY'],
  'Every Thursday': ['EVERY_THURSDAY'],
  'Every Friday': ['EVERY_FRIDAY'],
  'Every Saturday': ['EVERY_SATURDAY'],
  'Every Sunday': ['EVERY_SUNDAY'],
};

export const convertWeekdaysReverse: Record<string, string[]> = {
  ONE_DAY: ['One day'],
  EVERY_DAY: ['Every day'],
  EVERY_MONDAY: ['Every Monday'],
  EVERY_TUESDAY: ['Every Tuesday'],
  EVERY_WEDNESDAY: ['Every Wednesday'],
  EVERY_THURSDAY: ['Every Thursday'],
  EVERY_FRIDAY: ['Every Friday'],
  EVERY_SATURDAY: ['Every Saturday'],
  EVERY_SUNDAY: ['Every Sunday'],
};

export const toHumanDate = (
  date: string | number | Date,
  dateformat: string,
): string => format(utcToZonedTime(new Date(date), 'utc'), dateformat, { timeZone: 'utc' });

export const toMonthFormat = (
  dateformat: string,
  date?: string | number | Date,
): string => {
  if (date) {
    return moment(date).format(dateformat);
  }
  return '';
};

export const transformTimeFormat = (time: string | Date): string => format(utcToZonedTime(new Date(time), 'utc'), 'p', { timeZone: 'utc' });

export const transformTimeFormatLocale = (timeString: string): string => {
  if (!timeString) {
    return '';
  }
  const date = new Date(timeString);
  const formattedTime = moment(date).format('hh:mm A');
  return formattedTime;
};
